import React, { useEffect, useRef } from 'react'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Workbuild = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);

    useEffect(() => {
        const cards = cardRefs.current;

        const initialPositions = [
            { x: 0, y: 100, opacity: 0 },
            { x: 0, y: 150, opacity: 0 },
            { x: 0, y: 200, opacity: 0 },
            { x: 0, y: 250, opacity: 0 },
        ];

        cards.forEach((card, index) => {
            gsap.fromTo(
                card,
                initialPositions[index],
                {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: card,
                        start: "top 120%",
                        toggleActions: "play none none none",
                        //   markers: true
                    },
                }
            );

            gsap.set(card, { transformOrigin: "center" });

            card.addEventListener("mouseenter", () => {
                gsap.to(card, { scale: 1.05, duration: 0.3 });
            });

            card.addEventListener("mouseleave", () => {
                gsap.to(card, { scale: 1, duration: 0.3 });
            });
        });
    }, []);
    return (
        <>
            <section className='workingmainprnt'>
                <div className="custom-container" ref={sectionRef}>
                    <div className="workingmainchld">

                        <div className="imgleftworking displaynoneonmobile">
                            <img className='img-fluid' src="\assets\Buildimgs\buildandgroupsecondimg.png" alt="img" />
                        </div>
                        <div className="imgleftworking d-none displayshowonmobile" style={{position: "relative", zIndex: "9"}}>
                            <img className='img-fluid d-block m-auto' src="\assets\Buildimgs\buildandgroupsecondimgmbl.png" alt="img" style={{maxWidth: "60%"}} />
                            <img className='img-fluid mblbgviewcenterbackside' src="\assets\Buildimgs\buildandgroupsecondimgbackside.png" alt="img" />
                        </div>

                        <div className="rightcntworking">
                            <h2>How It Works</h2>
                            <div className="leftcntchldworking" ref={(el) => (cardRefs.current[0] = el)}>
                                <h3>1. Start a Group</h3>
                                <p>Choose a group name, topic, and invite members using a secure link or direct invite.</p>
                            </div>
                            <div className="leftcntchldworking" ref={(el) => (cardRefs.current[1] = el)}>
                                <h3>2. Set Monetization Rules</h3>
                                <p>Enable payment options for joining the group or accessing premium content.
                                </p>
                            </div>
                            <div className="leftcntchldworking" ref={(el) => (cardRefs.current[2] = el)}>
                                <h3>3. Customize Settings</h3>
                                <p>Adjust privacy levels, participant permissions, and moderation rules.</p>
                            </div>
                            <div className="leftcntchldworking" ref={(el) => (cardRefs.current[3] = el)}>
                                <h3>4. Engage and Earn</h3>
                                <p>Share updates, host discussions, and manage memberships while earning directly through the platform.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Workbuild